import BaseRenderer from 'diagram-js/lib/draw/BaseRenderer';

import {
  append as svgAppend,
  attr as svgAttr,
  classes as svgClasses,
  create as svgCreate,
  remove as svgRemove,
  innerSVG as svgInnerAppend,
} from 'tiny-svg';

import { getRoundRectPath } from 'bpmn-js/lib/draw/BpmnRenderUtil';

import { is } from 'bpmn-js/lib/util/ModelUtil';
import { isAny } from 'bpmn-js/lib/features/modeling/util/ModelingUtil';

import modeling from 'bpmn-js/lib/features/modeling';

const HIGH_PRIORITY = 1500;

export default class ClassifierRenderer extends BaseRenderer {
  constructor(eventBus, bpmnRenderer) {
    super(eventBus, HIGH_PRIORITY);

    this.bpmnRenderer = bpmnRenderer;
    // this.modeling = bpmnRenderer.get('modeling');

    // this.maxHeight = 0;
    this.elementWidth = 160;
    this.currentZoomLevel = 1;
  }

  canRender(element) {
    return is(element, 'bpmn:ScriptTask') && element.businessObject.subType === 'classifier-task';
  }

  svg_textMultiline(id, maxWidth, zoom) {
    var x = 10;
    var y = 0;
    var dy = 15;

    /* get the text */
    var element = document.getElementById(id);

    var text = element.innerHTML;

    var words = text.split(' ');
    var line = '';

    var constructedText = '';

    for (var n = 0; n < text.length; n++) {
      //
      element.innerHTML = '<tspan id="PROCESSING">busy</tspan >';

      var newTextLine = line + text[n];

      const newTextElem = document.getElementById('PROCESSING');

      newTextElem.innerHTML = newTextLine;
      var metrics = newTextElem.getBoundingClientRect();
      var newTextWidth = metrics.width;

      //

      if (newTextWidth > maxWidth - 2 * x * (zoom ? zoom : 1)) {
        if ((constructedText.match(/<tspan/g) || []).length > 0) {
          constructedText += '<tspan x="' + x + '" dy="' + dy + '">' + line + '</tspan>';
        } else {
          constructedText += '<tspan x="' + x + '" dy="' + y + '">' + line + '</tspan>';
        }
        line = text[n];
      } else {
        line = newTextLine;
      }

      document.getElementById('PROCESSING').remove();
    }
    if ((constructedText.match(/<tspan/g) || []).length > 0) {
      constructedText += '<tspan x="' + x + '" dy="' + dy + '">' + line + '</tspan>';
    } else {
      constructedText += '<tspan x="' + x + '" dy="' + y + '">' + line + '</tspan>';
    }

    element.innerHTML = constructedText;

    //
  }

  // Main function to draw custom shape

  drawShape(parentNode, element) {
    element.width = this.elementWidth;
    let element_id = `${element.id}${Math.floor(Math.random() * 10000)}`;

    let shapeProcessing = this.bpmnRenderer.drawShape(parentNode, element);

    this.lastActualWidth = shapeProcessing.getBoundingClientRect().width;
    //this.currentZoomLevel = 170/shapeProcessing.getBoundingClientRect().width;

    //

    const newText = svgCreate('text');
    svgAttr(newText, {
      id: `ResultTextFor${element_id}`,
      class: 'djs-label',
      x: 10,
      y: 35,
    });

    newText.appendChild(document.createTextNode(element.businessObject.classifierType || 'No classifier selected'));

    parentNode.appendChild(newText);

    const newLabelText = svgCreate('text');
    svgAttr(newLabelText, {
      id: `newLabelText`,
      class: 'djs-label-small',
      x: 10,
      y: 20,
    });

    newLabelText.appendChild(document.createTextNode('classifier type'));

    parentNode.appendChild(newLabelText);

    let zoom;
    if (shapeProcessing.getBoundingClientRect().width) {
      zoom = (shapeProcessing.getBoundingClientRect().width / this.elementWidth).toFixed(4);
    } else {
      zoom = 1;
    }

    let newClientRect;
    try {
      this.svg_textMultiline(`ResultTextFor${element_id}`, this.lastActualWidth, zoom);

      newClientRect = document.getElementById(`ResultTextFor${element_id}`).getBoundingClientRect();
    } catch (e) {
      newClientRect = {height: 15}
    }

    const newLabelText2 = svgCreate('text');
    svgAttr(newLabelText2, {
      id: `newLabelText`,
      class: 'djs-label-small',
      x: 10,
      y: 40 + (newClientRect.height || 15) * (1 / zoom),
    });

    newLabelText2.appendChild(document.createTextNode('variable name for result'));

    parentNode.appendChild(newLabelText2);

    const newText2 = svgCreate('text');
    svgAttr(newText2, {
      id: `ExpressionTextFor${element_id}`,
      class: 'djs-label',
      x: 10,
      y: 55 + (newClientRect.height || 15) * (1 / zoom),
    });

    newText2.appendChild(document.createTextNode(element.businessObject.identifierForResult || 'No variable name'));

    parentNode.appendChild(newText2);

    let MapMessageClientRect;
    try {
      this.svg_textMultiline(`ExpressionTextFor${element_id}`, this.lastActualWidth, zoom);

      MapMessageClientRect = document.getElementById(`ExpressionTextFor${element_id}`).getBoundingClientRect();
    } catch (e) {
      MapMessageClientRect = {height: 15};
    }

    let newHeight = Math.round(
      newClientRect.height + MapMessageClientRect.height + 60 * (zoom ? zoom : 1) > 90 * (zoom ? zoom : 1)
        ? newClientRect.height + MapMessageClientRect.height + 60 * (zoom ? zoom : 1)
        : 90 * (zoom ? zoom : 1)
    );
    let oldHeight = element.height;

    newHeight = zoom === 1 ? newHeight : newHeight * (1 / zoom);

    svgAttr(shapeProcessing, {
      height: newHeight,
    });

    element.width = this.elementWidth;
    element.height = newHeight;

    element.y = element.y - (newHeight / 2 - oldHeight / 2);

    let shape = this.bpmnRenderer.drawShape(parentNode, element);

    svgAttr(parentNode.childNodes[7], {
      fillOpacity: 0,
      strokeWidth: 3,
      stroke: '#0080FF',
      class: 'djs-rect',
    });

    svgRemove(parentNode.childNodes[0]);

    drawRect(parentNode);

    this.currentZoomLevel = zoom;

    return shape;
  }
}

ClassifierRenderer.$inject = ['eventBus', 'bpmnRenderer'];

// helpers //////////

// copied from https://github.com/bpmn-io/bpmn-js/blob/master/lib/draw/BpmnRenderer.js
function drawRect(parentNode, width, height, borderRadius, strokeColor) {
  const g = svgCreate('g');

  svgAttr(g, {
    transform: 'translate(-11, -11)',
    fill: 'white',
  });

  /*const rect = svgCreate('rect');

    svgAttr(rect, {
      width: width,
      height: height,
      fill: "#fff"
    });*/

  //svgAppend(g, rect);

  const rect = '<rect width="26" height="25" fill="white"></rect>';

  const iconContent =
    '<path d="M12 19V5.00003L12.001 3.55402C10.47 2.66502 8.482 2.86103 7.171 4.17203C6.045 5.29803 5.744 6.92602 6.242 8.33402C4.351 9.04802 3 10.86 3 13C3 14.655 3.814 16.111 5.052 17.021C5.314 19.258 7.193 21 9.5 21C10.425 21 11.285 20.719 12 20.24V19Z" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '    <path d="M6.53601 5C5.43101 6.913 6.08701 9.36 8.00001 10.464M11.994 10C11.996 11.654 10.657 12.998 9.00301 13" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '    <path d="M12 8H17V6" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '    <path d="M12 12H19" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '    <path d="M17 2C16.4696 2 15.9609 2.21071 15.5858 2.58579C15.2107 2.96086 15 3.46957 15 4C15 4.53043 15.2107 5.03914 15.5858 5.41421C15.9609 5.78929 16.4696 6 17 6C17.5304 6 18.0391 5.78929 18.4142 5.41421C18.7893 5.03914 19 4.53043 19 4C19 3.46957 18.7893 2.96086 18.4142 2.58579C18.0391 2.21071 17.5304 2 17 2ZM21 10C20.4696 10 19.9609 10.2107 19.5858 10.5858C19.2107 10.9609 19 11.4696 19 12C19 12.5304 19.2107 13.0391 19.5858 13.4142C19.9609 13.7893 20.4696 14 21 14C21.5304 14 22.0391 13.7893 22.4142 13.4142C22.7893 13.0391 23 12.5304 23 12C23 11.4696 22.7893 10.9609 22.4142 10.5858C22.0391 10.2107 21.5304 10 21 10Z" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '    <path d="M12 16H17V18" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '    <path d="M17 18C16.4696 18 15.9609 18.2107 15.5858 18.5858C15.2107 18.9609 15 19.4696 15 20C15 20.5304 15.2107 21.0391 15.5858 21.4142C15.9609 21.7893 16.4696 22 17 22C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20C19 19.4696 18.7893 18.9609 18.4142 18.5858C18.0391 18.2107 17.5304 18 17 18Z" stroke="#002348" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n';

  svgInnerAppend(g, rect + iconContent);

  svgAppend(parentNode, g);

  return g;
}

// copied from https://github.com/bpmn-io/diagram-js/blob/master/lib/core/GraphicsFactory.js
function prependTo(newNode, parentNode, siblingNode) {
  parentNode.insertBefore(newNode, siblingNode || parentNode.firstChild);
}
